import {useEffect, useMemo, useRef} from 'react'
import throttle from 'lodash/throttle'

export function useThrottle(fn, wait = 100, options) {
    const fnRef = useRef(fn)

    useEffect(() => {
        fnRef.current = fn
    }, [fn])

    const throttled = useMemo(() => {
        return throttle((...args) => fnRef.current(...args), wait, options)
    }, [wait, options])

    useEffect(() => {
        return () => throttled.cancel()
    }, [throttled])

    return throttled
}
